import React, { useEffect, useState } from 'react';

import { useNavigate, useParams, Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import { setProjectData, setIsUpdatePending } from '@modules/editor';

import { Box, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import api from '@utils/axiosInstance';

function InfoCardMenu() {

    const projectData = useSelector(state => state.editor.projectData);
    const projectInfo = useSelector(state => state.editor.projectInfo);
    const editProjIdx = useSelector(state => state.editor.editProjIdx);
    const { uuid } = useParams();

    const userToken = useSelector(state => state.organization.userToken);
    const organizationData = useSelector(state => state.organization.organizationData);

    const [infoCardList, setInfoCardList] = useState([]);
    const [changedObj, setchangedObj] = useState({});

    const dispatch = useDispatch();

    useEffect(() => {
        if (projectData[0].length > 0) {
            projectData[0].map((el, idx) => {
                if (el.action == "infoCard") {
                    setInfoCardList(el.data);
                }
            })
        }
    }, [projectData])

    function handleChange(idx, type, text) {

        var tmpArr = infoCardList[idx];

        if (type == 'from') {
            setchangedObj({
                ...tmpArr,
                'from': text
            });
        }
        else if (type == 'to') {
            setchangedObj({
                ...tmpArr,
                'to': text
            })
        }
    }

    function addCard() {

        var tmpList = infoCardList;
        tmpList.push(
            {
                'title': '',
                'from': '00:00:000',
                'to': '00:00:000'
            }
        );
        setInfoCardList([...tmpList])
    }

    function fetchText(e, idx) {
        e.preventDefault();

        var tmpCardList = [...infoCardList];
        tmpCardList[idx] = changedObj;
        setInfoCardList(tmpCardList);

        var tmpProjectData = projectData;
        if (projectData.length > 0) {
            projectData.map((el, idx) => {
                if (el.action == "infoCard") {
                    tmpProjectData.splice(idx, 1);
                }
            })
        }
        tmpProjectData.push({
            "action": "infoCard",
            "data": tmpCardList
        });

        dispatch(setProjectData(tmpProjectData));
        dispatch(setIsUpdatePending(true));

        api({
            method: 'post',
            url: '/editor/update',
            data: {
                tk: userToken,
                uuid: uuid,
                ogc: organizationData.organization_code,
                project_id: editProjIdx,
                projectInfo: projectInfo,
                projectData: tmpProjectData
            }
        })
            .then((response) => {
                console.log(response.data.data);
                dispatch(setIsUpdatePending(false));
            })
            .catch((error) => {
                console.log(error);
                dispatch(setIsUpdatePending(false));
            });
    }
    return (
        <Box className="info-card-menu">
            {infoCardList.map((el, idx) => (
                <Box
                    key={`crop_${idx}`}
                    className='menu-box-row'
                    onBlur={(e) => fetchText(e, idx)}
                >
                    <Box className="column video-column">
                        <Typography variant="body1" className="video-text">
                            동영상
                        </Typography>
                    </Box>
                    <Box className="column new-window-column">
                        <Typography variant="body1">새로운 창</Typography>
                    </Box>
                    <Box className="column title-column">
                        <Typography variant="body1">{el.title}</Typography>
                    </Box>
                    <Box className="column time-column">
                        <Box
                            className='editor editable-text'
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            onInput={(e) => handleChange(idx, 'from', e.currentTarget.textContent)}
                        >
                            <Typography variant="body1">{el.from}</Typography>
                        </Box>
                        <Typography variant="body1" className="time-separator">-</Typography>
                        <Box
                            className='editor editable-text'
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            onInput={(e) => handleChange(idx, 'to', e.currentTarget.textContent)}
                        >
                            <Typography variant="body1">{el.to}</Typography>
                        </Box>
                    </Box>
                    <Box className="column trash-column">
                        <IconButton className="trash-button">
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                </Box>
            ))}
            <Box
                className="plus-btn"
                onClick={() => addCard()}
            >
                <IconButton className='plus-btn-icon'>
                    <AddIcon />
                </IconButton>
            </Box>
        </Box>
    );
}

export default InfoCardMenu;
